import React from 'react';
import { SvgProps, Svg } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11 0C17.0751 0 22 4.92487 22 11C22 17.0751 17.0751 22 11 22C4.92487 22 0 17.0751 0 11C0 4.92487 4.92487 0 11 0ZM11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2ZM8 7C8 6.2013 8.89015 5.72491 9.5547 6.16795L15.5547 10.1679C16.1484 10.5638 16.1484 11.4362 15.5547 11.8321L9.5547 15.8321C8.89015 16.2751 8 15.7987 8 15V7ZM10 8.869V13.13L13.196 11L10 8.869Z"
        fill="#EEAD8B"
      />
    </Svg>
  );
};

export default Icon;
